import * as React from 'react';
import * as PropTypes from 'prop-types'

import { ActivityFormatProduct } from '../diary/helpers';
import { isNullOrEmpty } from '../../../utils/util';
import { TimeFormat } from '../../../store/pages/venues/types';
import ProductListItem from "./productListItem";
import { ProductStockLevel } from "../../../store/pages/productStock/types";
import { ApplicationState } from "../../../store";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as LoginActions from '../../../store/pages/login/actions';

interface MappedReduxState {
    selectedVenueId: string;
}

interface Actions {
    logout: () => void;
}

interface LocalProps {
    categoryName: string;
    products: ActivityFormatProduct[];
    productStockLevels: ProductStockLevel[];
    timeFormat: TimeFormat;
    customerSelectionRequired: boolean;
    productSelected: (productId: string, productVariantId: string | null, customerCategoryId: string | null, quantity: number, reservationId: string | null) => void;
}

type ProductsPanelProps = MappedReduxState & Actions & LocalProps;

interface CategoryProducts {
    categoryName: string;
    products: ActivityFormatProduct[];
}

const ProductsPanel: React.FC<ProductsPanelProps> = (props, context) => {
    const { products, productStockLevels, timeFormat } = props;
    const { t } = context;

    const selectProduct = (product: ActivityFormatProduct, quantity: number, productVariantId: string | null) => {
        // Prevent selection if customer selection is required
        if (!props.customerSelectionRequired) {
            props.productSelected(product.product.id, productVariantId, product.customerCategoryId, quantity, product.reservationId);
        }
    }

    const productsByCategory = products.filter(p => !p.product || !p.product.archived).reduce<CategoryProducts[]>((acc, p) => {
        const catName = p.customerCategoryName || '';
        let cat = acc.find(c => c.categoryName === catName);
        if (!cat) {
            cat = { categoryName: catName, products: [] };
            acc.push(cat);
        }

        cat.products.push(p);
        return acc;
    }, [])

    const renderHeading = productsByCategory.length > 1;

    return (
        <>
            {props.customerSelectionRequired ? <div className='alert alert-warning'>{t('ProductsPanel:customerReuired', {categoryName: props.categoryName})}</div> : null}
            {
                productsByCategory.map(c => (
                    <div key={c.categoryName}>
                        {renderHeading && !isNullOrEmpty(c.categoryName) ? <h3>{t('ProductsPanel:customerCategoryHeading', { categoryName: c.categoryName })}</h3> : null}
                        <ul key={`${c.categoryName}_products`} className='list-unstyled pos_product_list'>
                            {c.products.map(p => {
                                return <ProductListItem 
                                    key={p.key} 
                                    activityFormatProduct={p}
                                    timeFormat={timeFormat}
                                    onSelectProduct={selectProduct}
                                    productStockLevels={productStockLevels.filter(psl => psl.productId === p.product.id)} 
                                />
                            })}
                        </ul>
                    </div>
                ))
            }
        </>
    )
}

ProductsPanel.contextTypes = {
    t: PropTypes.func
}


const mapStateToProps = (state: ApplicationState) => ({
    selectedVenueId: state.venues.selectedVenueId
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logout: bindActionCreators(LoginActions.actionCreators.logout, dispatch),
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductsPanel);
